<div class="ap-chat-textarea" data-testid="chat-textarea-wrapper">
    <ap-textarea
        [autoGrow]="1"
        [rows]="1"
        [maxCharacters]="maxCharacters()"
        [maxlength]="maxCharacters()"
        [formControl]="control()"
        [label]="label() | apContent"
        (textareaBlur)="textareaBlur.emit($event)"
        (iconClick)="iconClick.emit($event)"
        icon="send"
        data-testid="chat-textarea-textarea"
    ></ap-textarea>
</div>
